import {createRouter, createWebHashHistory} from "vue-router";
import Snow from "./arts/Snow";
import Main from "./components/Main";
import Chess from "./apps/chess/Chess";
import MoscowCityTower from "./arts/MoscowCityTower"
import LeakCheck from "./apps/coding/LeakCheck"
import PasswordGenerator from "./apps/PasswordGenerator"
import ListsCompare from "@/apps/ListsCompare";

export default createRouter({
    history: createWebHashHistory(),
    routes: [
        {path: '/', component: Main},
        {path: '/snow', component: Snow},
        {path: '/chess', component: Chess},
        {path: '/moscow-city-tower', component: MoscowCityTower},
        {path: '/leak-check', component: LeakCheck},
        {path: '/pwd-generator', component: PasswordGenerator},
        {path: '/lists-compare', component: ListsCompare},
    ]
})
